const SettingsMenuItem = ({ label, onClick, icon, highlight = false, danger = false }) => {
  let baseClasses = `
    w-full flex justify-between items-center px-4 py-3 rounded-xl
    hover:bg-gray-50 transition-all duration-200
  `;

  if (highlight) {
    baseClasses += ' bg-brandPurpleLight border border-brandPurpleDark shadow text-brandPurpleDark';
  } else if (danger) {
    baseClasses += ' bg-white text-red-500 border border-red-400 hover:bg-red-50';
  } else {
    baseClasses += ' bg-white border border-gray-400';
  }

  return (
    <button onClick={onClick} className={baseClasses}>
      <span className="flex items-center gap-2">
        {label}
      </span>
      {icon && (
        <span className="flex items-center gap-2 justify-end">
          {icon}
        </span>
      )}
    </button>
  );
};


export default SettingsMenuItem;
